module.exports = __webpack_public_path__ + "img/brand.2eb689bd.svg";